import { MyNotesStoreFactory } from 'common/data/my-notes/store.factory';
import { MyNotesServiceInterface } from 'common/service/my-notes/service.interface';

const myNotesService = MyNotesStoreFactory();

export function MyNotesService(): MyNotesServiceInterface {
  return myNotesService;
}
